const offsetString = (timeZone) => {
  const parts = new Intl.DateTimeFormat('en-US', {timeZone, timeZoneName: 'shortOffset'}).formatToParts(new Date());
  return parts.find(p => p.type === 'timeZoneName')?.value ?? 'GMT';
};

const offsetMinutes = (offset) => {
  const match = offset.match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
  if (!match) return 0;
  const [, sign, hours, minutes = '0'] = match;
  return (sign === '-' ? -1 : 1) * (parseInt(hours, 10) * 60 + parseInt(minutes, 10));
};

const label = (timeZone, offset) => {
  const segments = timeZone.split('/');
  const city = segments.pop().replace(/_/g, ' ');
  const region = segments.join('/');
  return region ? `${city} (${region}), ${offset}` : `${city}, ${offset}`;
};

export const browserTimeZoneAbbreviation = (date) => (
  new Intl.DateTimeFormat('en-US', {timeZoneName: 'short'}).
    formatToParts(date).
    find(part => part.type === 'timeZoneName').
    value
);

export const timeZoneOptions = Intl.supportedValuesOf('timeZone').
  map(timeZone => {
    const offset = offsetString(timeZone);
    return {value: timeZone, label: label(timeZone, offset), offsetMinutes: offsetMinutes(offset)};
  }).
  sort((a, b) => a.offsetMinutes - b.offsetMinutes || a.label.localeCompare(b.label));
